
        var result = require("!!../../../../../node_modules/css-loader/index.js!./orgs.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/quote-settings/orgs/orgs.component.css
// module id = 745
// module chunks = 0